import { render, staticRenderFns } from "./FilterMessages.vue?vue&type=template&id=24b5c066&scoped=true&"
import script from "./FilterMessages.vue?vue&type=script&lang=ts&"
export * from "./FilterMessages.vue?vue&type=script&lang=ts&"
import style0 from "./FilterMessages.vue?vue&type=style&index=0&id=24b5c066&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b5c066",
  null
  
)

export default component.exports